import { put, call, select } from "redux-saga/effects";
import {
    deleteSchedulerRule,
    fetchSchedulerOverviewConfigs,
} from "store/features/emailScheduler/overview/overview.actions";
import emailScheduler, { SchedulerConfiguration } from "api/emailScheduler";
import { buildEmailSchedulerConfigsViewModel } from "api/factories/emailScheduler.factory";
import { resetApiError, riseError } from "store/features/general/general.actions";
import { getExceptions } from "store/features/emailScheduler/definition/definition.selectors";
import { SchedulerExceptionForm } from "validation/components/EmailScheduler/exceptionsFormRules";
import { fetchEmailSchedulerRuleExceptionSaga } from "../exceptions/exceptions.sagas";

export function* fetchEmailSchedulerOverviewSaga(headers: HeadersInit): Generator {
    const existingExceptions = (yield select(getExceptions)) as SchedulerExceptionForm[];

    try {
        const rules = (yield call(emailScheduler.getSchedulerConfiguration, headers)) as SchedulerConfiguration;

        if (!existingExceptions.length) {
            yield call(fetchEmailSchedulerRuleExceptionSaga, headers);
        }

        yield put(
            fetchSchedulerOverviewConfigs.success({
                emailConfigurations: buildEmailSchedulerConfigsViewModel(rules),
            })
        );
    } catch (err) {
        if (err.status) {
            yield put(fetchSchedulerOverviewConfigs.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* deleteEmailSchedulerOverviewSaga(
    headers: HeadersInit,
    action: ReturnType<typeof deleteSchedulerRule.request>
): Generator {
    try {
        yield call(emailScheduler.deleteSchedulerRule, action.payload, headers);
        yield put(deleteSchedulerRule.success());
        yield call(fetchEmailSchedulerOverviewSaga, headers);
    } catch (err) {
        if (err.status) {
            yield put(deleteSchedulerRule.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}
